function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Card from "semantic-ui-react/dist/es/views/Card/Card.js";
import Segment from "semantic-ui-react/dist/es/elements/Segment/Segment.js";
import classnames from 'classnames';
import { getToggledIsActiveState } from "../../../utils/get-toggled-is-active-state";
import { getCardPlaceholderMarkup } from "../../../utils/get-card-placeholder-markup";
import { Rating } from "../../elements/Rating";
import { ResponsiveImage } from "../../media/ResponsiveImage";
import { Paragraph } from "../../typography/Paragraph";
import { Heading } from "../../typography/Heading";
import { FlexContainer } from "../../layout/FlexContainer";
import { PriceLabel } from "../../elements/PriceLabel";
import { getPropertyTypeWithDot } from "./utils/getPropertyTypeWithDot";
import { getSearchResultDescription } from "./utils/getSearchResultDescription";
import { getPropertyAmenities } from "./utils/getPropertyAmenities";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isActive: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (previousProps, previousState) {
      var isActive = _this.state.isActive;
      if (previousState.isActive === isActive) return;
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      onChange(name, isActive);
    });

    _defineProperty(_assertThisInitialized(_this), "toggleActive", function () {
      return _this.setState(getToggledIsActiveState);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props2 = _this.props,
          bathsNumber = _this$props2.bathsNumber,
          bathsText = _this$props2.bathsText,
          bedroomsNumber = _this$props2.bedroomsNumber,
          bedroomsText = _this$props2.bedroomsText,
          bedsNumber = _this$props2.bedsNumber,
          bedsText = _this$props2.bedsText,
          guestsNumber = _this$props2.guestsNumber,
          guestsText = _this$props2.guestsText,
          imageSizes = _this$props2.imageSizes,
          imageSrcSet = _this$props2.imageSrcSet,
          imageTitle = _this$props2.imageTitle,
          imageUrl = _this$props2.imageUrl,
          isActive = _this$props2.isActive,
          isCompact = _this$props2.isCompact,
          isShowingPlaceholder = _this$props2.isShowingPlaceholder,
          placeholderImageUrl = _this$props2.placeholderImageUrl,
          priceLabelPeriodText = _this$props2.priceLabelPeriodText,
          priceLabelPricePerPeriod = _this$props2.priceLabelPricePerPeriod,
          priceLabelPricePerPeriodPrefix = _this$props2.priceLabelPricePerPeriodPrefix,
          propertyAmenities = _this$props2.propertyAmenities,
          propertyName = _this$props2.propertyName,
          propertyType = _this$props2.propertyType,
          propertyUrl = _this$props2.propertyUrl,
          propertyUrlTarget = _this$props2.propertyUrlTarget,
          ratingNumber = _this$props2.ratingNumber;
      return React.createElement("div", {
        className: classnames('ui', 'card', 'has-search-result', {
          active: isActive || _this.state.isActive,
          'is-compact': isCompact
        }),
        onMouseOut: _this.toggleActive,
        onMouseOver: _this.toggleActive
      }, React.createElement(Card, {
        href: propertyUrl,
        target: propertyUrlTarget
      }, isShowingPlaceholder ? getCardPlaceholderMarkup() : React.createElement(Fragment, null, React.createElement(FlexContainer, null, React.createElement(ResponsiveImage, {
        imageTitle: imageTitle,
        imageUrl: imageUrl,
        placeholderImageUrl: placeholderImageUrl,
        sizes: imageSizes,
        srcSet: imageSrcSet,
        willFill: true
      }), !isCompact && React.createElement(Segment, {
        raised: true
      }, React.createElement(PriceLabel, {
        periodText: priceLabelPeriodText,
        pricePerPeriod: priceLabelPricePerPeriod,
        pricePerPeriodPrefix: priceLabelPricePerPeriodPrefix
      }))), React.createElement(Card.Content, null, React.createElement(Card.Header, null, React.createElement(Heading, null, propertyName)), React.createElement(Card.Description, null, React.createElement(FlexContainer, {
        alignItems: "center",
        flexDirection: "row"
      }, ratingNumber >= 1 && React.createElement(Rating, {
        iconSize: "tiny",
        ratingNumber: ratingNumber
      }), React.createElement(Paragraph, {
        size: "medium"
      }, getPropertyTypeWithDot(ratingNumber, propertyType)))), React.createElement(Card.Description, null, getSearchResultDescription(bathsNumber, bathsText, bedroomsNumber, bedroomsText, bedsNumber, bedsText, guestsNumber, guestsText)), React.createElement(Card.Description, null, getPropertyAmenities(propertyAmenities)), isCompact && React.createElement(FlexContainer, {
        justifyContent: "flex-end"
      }, React.createElement(PriceLabel, {
        periodText: priceLabelPeriodText,
        pricePerPeriod: priceLabelPricePerPeriod,
        pricePerPeriodPrefix: priceLabelPricePerPeriodPrefix
      }))))));
    });

    return _this;
  }

  return Component;
}(PureComponent);
Component.displayName = 'PropertySearchResult';
Component.defaultProps = {
  bathsNumber: null,
  bathsText: '',
  bedroomsNumber: null,
  bedroomsText: '',
  bedsNumber: null,
  bedsText: '',
  imageSizes: undefined,
  imageSrcSet: undefined,
  imageTitle: '',
  isActive: false,
  isCompact: false,
  isShowingPlaceholder: false,
  name: undefined,
  onChange: Function.prototype,
  placeholderImageUrl: undefined,
  priceLabelPeriodText: '',
  priceLabelPricePerPeriod: '',
  priceLabelPricePerPeriodPrefix: '',
  propertyAmenities: [],
  propertyUrlTarget: '_self'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  bathsNumber: PropTypes.number,
  bathsText: PropTypes.string,
  bedroomsNumber: PropTypes.number,
  bedroomsText: PropTypes.string,
  bedsNumber: PropTypes.number,
  bedsText: PropTypes.string,
  guestsNumber: PropTypes.number.isRequired,
  guestsText: PropTypes.string.isRequired,
  imageSizes: PropTypes.string,
  imageSrcSet: PropTypes.string,
  imageTitle: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isCompact: PropTypes.bool,
  isShowingPlaceholder: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  placeholderImageUrl: PropTypes.string,
  priceLabelPeriodText: PropTypes.string,
  priceLabelPricePerPeriod: PropTypes.string,
  priceLabelPricePerPeriodPrefix: PropTypes.string,
  propertyAmenities: PropTypes.arrayOf(PropTypes.string),
  propertyName: PropTypes.string.isRequired,
  propertyType: PropTypes.string.isRequired,
  propertyUrl: PropTypes.string.isRequired,
  propertyUrlTarget: PropTypes.string,
  ratingNumber: PropTypes.number.isRequired
} : {};